const state_number = [
    {
        label: '1',
        value: '1',
    },
    {
        label: '2',
        value: '2',
    },
    {
        label: '3',
        value: '3',
    },
    {
        label: '4',
        value: '4',
    },
    {
        label: '5',
        value: '5',
    },
    {
        label: '6',
        value: '6',
    },
    {
        label: '7',
        value: '7',
    },
    {
        label: '8',
        value: '8',
    },
    {
        label: '9',
        value: '9',
    },
    {
        label: '10',
        value: '10',
    },
    {
        label: '11',
        value: '11',
    },
    {
        label: '12',
        value: '12',
    },
    {
        label: '13',
        value: '13',
    },
    {
        label: '14',
        value: '14',
    },
];

const district = [
    {
        state: '1',
        district: [
            'AhGaYa',
            'BaMaNa',
            'DaPhaYa',
            'HaPaNa',
            'KaMaNa',
            'KhaBaDa',
            'KhaLaPha',
            'KhaPhaNa',
            'LaGaNa',
            'MaKaNa',
            'MaKaTa',
            'MaKhaBa',
            'MaMaNa',
            'NaMaNa',
            'MaNyaNa',
            'MaSaNa',
            'PaNaDa',
            'PaTaAh',
            'SaLaNa',
            'SaPaBa',
            'TaNaNa',
            'WaMaNa',
            'YaKaNa',
        ],
    },
    {
        state: '2',
        district: [
            'BaLaKha',
            'DaMaSa',
            'BaLaKha',
            'DaMaSa',
            'LaKaNa',
            'MaSaNa',
            'PhaSaNa',
            'PhaYaSa',
            'YaTaNa',
            'YaThaNa',
        ],
    },
    {
        state: '3',
        district: [
            'BaAhNa',
            'BaThaSa',
            'KaSaKa',
            'KaDaNa',
            'KaKaYa',
            'LaBaNa',
            'MaWaTa',
            'PaKaNa',
            'PhaPaNa',
            'ThaTaKa',
            'ThaTaNa',
        ],
    },
    {
        state: '4',
        district: [
            'HaKhaNa',
            'HtaTaLa',
            'KaKhaNa',
            'KaPaLa',
            'MaTaNa',
            'MaTaPa',
            'PaLaWa',
            'PhaLaNa',
            'TaTaNa',
            'TaZaNa',
            'YaKhaDa',
            'YaZaNa',
        ],
    },
    {
        state: '5',
        district: [
            'AhTaNa',
            'AhYaTa',
            'BaMaNa',
            'BaTaLa',
            'DaPaYa',
            'HaMaLa',
            'HtaKhaNa',
            'KaBaLa',
            'KaLaHta',
            'KaLaNa',
            'KaLaTa',
            'KaLaWa',
            'KaNaNa',
            'KaMaNa',
            'KhaTaNa',
            'KaThaNa',
            'KhaOoNa',
            'KhaOoTa',
            'LaHaNa',
            'LaYaNa',
            'MaKaNa',
            'MaLaNa',
            'MaMaTa',
            'MaThaNa',
            'NaYaNa',
            'NgaZaNa',
            'PaLaNa',
            'PaSaNa',
            'SaKaNa',
            'SaLaKa',
            'TaSaNa',
            'WaLaNa',
            'YaBaNa',
            'YaMaPa',
            'MaMaNa',
            'MaYaNa',
            'PaLaBa',
            'PhaPaNa',
            'TaMaNa',
            'WaThaNa',
            'YaONa',
        ],
    },
    {
        state: '6',
        district: [
            'BaPaNa',
            'HtaWaNa',
            'KaThaNa',
            'KaYaYa',
            'LaLaNa',
            'MaAhNa',
            'MaAhYa',
            'PaLaNa',
            'TaThaYa',
            'YaPhaNa',
            'MaMaNa',
            'KaSaNa',
            'KhaMaKa',
            'MaTaNa',
            'ThaYaKha',
        ],
    },
    {
        state: '7',
        district: [
            'AhPhaNa',
            'AhPhaNa',
            'AhPhaNa',
            'DaOoNa',
            'HtaTaPa',
            'KaPaKa',
            'KaTaKha',
            'LaPaTa',
            'MaLaNa',
            'NaTaLa',
            'NyaLaPa',
            'PaKhaNa',
            'PaMaNa',
            'PaTaNa',
            'PhaMaNa',
            'TaNgaNa',
            'ThaNaPa',
            'ThaWaTa',
            'YaKaNa',
            'YaTaNa',
            'ZaKaNa',
            'AhTaNa',
            'KaKaNa',
            'KaWaNa',
            'MaNyaNa',
            'PaKhaTa',
            'PaTaTa',
            'ThaKaNa',
            'WaMaNa',
            'YaTaYa',
        ],
    },
    {
        state: '8',
        district: [
            'AhLaNa',
            'HtaLaNa',
            'KaHtaNa',
            'KhaMaNa',
            'MaBaNa',
            'MaLaNa',
            'MaMaNa',
            'MaTaNa',
            'NaMaNa',
            'NgaPhaNa',
            'PaMaNa',
            'PaPhaNa',
            'SaMaNa',
            'SaPaWa',
            'SaTaYa',
            'TaTaKa',
            'YaNaKha',
            'YaSaKa',
            'GaGaNa',
            'KaMaNa',
            'MaKaNa',
            'MaThaNa',
            'PaKhaKa',
            'SaLaNa',
            'SaPhaNa',
            'ThaYaNa',
        ],
    },
    {
        state: '9',
        district: [
            'AhMaZa',
            'KaPaTa',
            'KaSaNa',
            'KhaMaSa',
            'LaWaNa',
            'MaHtaLa',
            'MaKaNa',
            'MaLaNa',
            'MaMaNa',
            'MaNaTa',
            'MaTaYa',
            'MaYaMa',
            'MaYaTa',
            'NgaThaYa',
            'NyaONa',
            'PaBaNa',
            'PaMaNa',
            'PaOLa',
            'SaKaNa',
            'SaKaTa',
            'TaKaTa',
            'TaTaOo',
            'ThaPaKa',
            'ThaSaNa',
            'YaMaTha',
            'OoTaTha',
            'ZaYaTha',
            'PaBaTha',
            'DaKhaTha',
            'ZaBaTha',
            'AhMaYa',
            'KhaAhZa',
            'MaHaMa',
            'MaKhaNa',
            'MaNaMa',
            'MaThaNa',
            'NaHtaKa',
            'PaKaKha',
            'PaThaKa',
            'TaKaNa',
            'TaThaNa',
            'WaTaNa',
        ],
    },
    {
        state: '10',
        district: [
            'BaLaNa',
            'KaMaYa',
            'KhaSaNa',
            'LaMaNa',
            'MaLaMa',
            'PaMaNa',
            'ThaPhaYa',
            'YaMaNa',
            'KaHtaNa',
            'MaDaNa',
            'ThaHtaNa',
        ],
    },
    {
        state: '11',
        district: [
            'BaThaTa',
            'GaMaNa',
            'KaPhaNa',
            'KaTaNa',
            'MaAhNa',
            'MaAhTa',
            'MaPaTa',
            'MaONa',
            'MaPaNa',
            'MaTaNa',
            'PaNaKa',
            'PaTaNa',
            'SaTaNa',
            'TaKaNa',
            'ThaTaNa',
            'YaBaNa',
            'YaThaTa',
            'AhMaNa',
            'KaTaLa',
        ],
    },
    {
        state: '12',
        district: [
            'AhLaNa',
            'AhSaNa',
            'BaHaNa',
            'BaTaHta',
            'DaGaMa',
            'DaGaNa',
            'DaGaSa',
            'DaGaTa',
            'DaGaYa',
            'DaLaNa',
            'DaPaNa',
            'HtaTaPa',
            'KaKaKa',
            'KaKhaKa',
            'KaMaNa',
            'KaMaTa',
            'KaMaYa',
            'KaTaNa',
            'KaTaTa',
            'KhaYaNa',
            'LaKaNa',
            'LaMaNa',
            'LaMaTa',
            'LaThaNa',
            'LaThaYa',
            'MaBaNa',
            'MaGaDa',
            'MaGaTa',
            'MaYaKa',
            'OKaMa',
            'OKaTa',
            'PaBaTa',
            'PaZaTa',
            'SaKaKha',
            'SaKaNa',
            'SaKhaNa',
            'TaKaNa',
            'TaMaNa',
            'TaTaNa',
            'TaTaTa',
            'ThaGaKa',
            'ThaKaTa',
            'ThaKhaNa',
            'ThaLaNa',
            'YaKaNa',
            'YaPaTha',
        ],
    },
    {
        state: '13',
        district: [
            'AhTaNa',
            'HaMaNa',
            'HaPaNa',
            'HaPaTa',
            'KaHaNa',
            'KaKaNa',
            'KaKhaNa',
            'KaLaHta',
            'KaLaNa',
            'KaLaTa',
            'KaMaNa',
            'KaTaKa',
            'KaTaNa',
            'KaTaTa',
            'KaThaNa',
            'KhaYaHa',
            'LaKaNa',
            'LaKhaNa',
            'LaKhaTa',
            'LaLaNa',
            'LaYaNa',
            'MaBaNa',
            'MaHaYa',
            'MaKaNa',
            'MaKaTa',
            'MaKhaNa',
            'MaKhaTa',
            'MaLaNa',
            'MaMaHta',
            'MaMaNa',
            'MaMaTa',
            'MaNaNa',
            'MaNaTa',
            'MaNgaNa',
            'MaPaHta',
            'MaPaNa',
            'MaPaTa',
            'MaPhaNa',
            'MaPhaTa',
            'MaSaNa',
            'MaSaTa',
            'MaHtaTa',
            'MaTaNa',
            'MaTaTa',
            'MaYaHta',
            'MaYakaukTa',
            'MaYaNa',
            'MaYapalatTa',
            'NaKhaNa',
            'NaKhaTa',
            'NaMaTa',
            'NaPhaNa',
            'NaSalaneNa',
            'NaSaloneNa',
            'NaTaNa',
            'NyaYaNa',
            'PhaKhaNa',
            'PaLaNa',
            'PaLaTa',
            'PaPaKa',
            'PaTaYa',
            'PaWaNa',
            'PaYaNa',
            'SaSaNa',
            'TaKaNa',
            'TaKhaLa',
            'TaLaNa',
            'TaMaNya',
            'TaTaNa',
            'TaYaNa',
            'ThaNaNa',
            'ThaPaNa',
            'YaNgaNa',
            'YaSaNa',
        ],
    },
    {
        state: '14',
        district: [
            'AhGaPa',
            'AhMaNh',
            'AhMaTa',
            'BaKaLa',
            'DaDaYa',
            'DaNaPha',
            'HaKaKa',
            'HaThaTa',
            'KaKaTa',
            'KaKaNa',
            'KaKhaNa',
            'KaLaNa',
            'KaPaNa',
            'LaMaNa',
            'LaPaTa',
            'MaAhNa',
            'MaAhPa',
            'MaMaKa',
            'MaMaNa',
            'NgaPaTa',
            'NgaSaNa',
            'NgaThaKha',
            'NgaYaKa',
            'NyaTaNa',
            'PaSaLa',
            'PaTaNa',
            'PaThaNa',
            'PaThaYa',
            'PhaPaNa',
            'ThaPaNa',
            'WaKhaMa',
            'YaKaNa',
            'YaThaYa',
            'ZaLaNa',
        ],
    },
];

const nationality = [
    { label: '(N)', value: '(N)' },
    { label: '(P)', value: '(P)' },
    { label: '(E)', value: '(E)' },
    { label: '(T)', value: '(T)' },
];

const getDistrict = (state) => {
    const index = district.findIndex((item) => item.state === state);
    const result = district[index] === undefined ? { state: '', district: [] } : district[index];
    const temp_districts = [];
    if (result.district.length > 0) {
        result.district.forEach((item) => {
            temp_districts.push({ label: item, value: item });
        });
    }
    return temp_districts;
};

export { state_number, district, nationality, getDistrict };
